<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <h6>用戶管理</h6>
            <!-- Filters -->
            <div class="row mt-3">
              <div class="col-md-3">
                <label>電子郵件</label>
                <soft-input
                  v-model="filters.email"
                  placeholder="搜尋電子郵件"
                  icon="email"
                />
              </div>
              <div class="col-md-3">
                <label>電話</label>
                <soft-input
                  v-model="filters.phone"
                  placeholder="搜尋電話"
                  icon="smartphone"
                />
              </div>
              <div class="col-md-3">
                <label>狀態</label>
                <select class="form-control" v-model="filters.status">
                  <option value="">所有狀態</option>
                  <option value="active">啟用</option>
                  <option value="suspended">停權</option>
                </select>
              </div>
              <div class="col-md-3">
                <label>賣家身分</label>
                <select class="form-control" v-model="filters.is_seller">
                  <option value="">全部</option>
                  <option value="1">賣家</option>
                  <option value="0">買家</option>
                </select>
              </div>
            </div>
            <div class="row mt-3 mb-3">
              <div class="col-md-12 d-flex justify-content-end">
                <soft-button
                  color="primary"
                  size="sm"
                  class="me-2"
                  @click="fetchUsers"
                  >搜尋</soft-button
                >
                <soft-button color="secondary" size="sm" @click="resetFilters"
                  >重置</soft-button
                >
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      用戶編號
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      用戶資訊
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      角色
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      警告次數
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      加入時間
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      社群綁定
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in users" :key="user.id">
                    <td class="ps-4">
                      <p class="text-xs font-weight-bold mb-0">
                        #{{ user.id }}
                      </p>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <img
                            :src="user.avatar || 'https://placehold.co/100'"
                            class="avatar avatar-sm me-3"
                            alt="user"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.name }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.email }}
                          </p>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.phone || "無電話" }}
                            <span
                              v-if="user.phone_verified_at"
                              class="text-success ms-1"
                              >(已驗證)</span
                            >
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span
                        class="badge badge-sm bg-gradient-info"
                        v-if="user.is_seller"
                        >賣家</span
                      >
                      <span class="badge badge-sm bg-gradient-secondary" v-else
                        >買家</span
                      >
                    </td>
                    <td class="align-middle text-center text-sm">
                      <soft-badge
                        :color="user.status === 'active' ? 'success' : 'danger'"
                        variant="gradient"
                        size="sm"
                      >
                        {{ user.status === "active" ? "啟用" : "停權" }}
                      </soft-badge>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        user.warning_count || 0
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        new Date(user.created_at).toLocaleDateString()
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <div class="d-flex justify-content-center gap-2">
                        <i
                          class="fab fa-line text-lg"
                          :class="
                            user.line_id
                              ? 'text-success'
                              : 'text-secondary opacity-2'
                          "
                          :title="user.line_id ? '已綁定 LINE' : '未綁定'"
                        ></i>
                        <i
                          class="fab fa-google text-lg"
                          :class="
                            user.google_id
                              ? 'text-danger'
                              : 'text-secondary opacity-2'
                          "
                          :title="user.google_id ? '已綁定 Google' : '未綁定'"
                        ></i>
                      </div>
                    </td>
                    <td class="align-middle">
                      <div class="dropdown" v-if="can('users.manage')">
                        <button
                          class="btn btn-link text-secondary mb-0"
                          data-bs-toggle="dropdown"
                        >
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class="dropdown-item"
                              href="javascript:;"
                              @click="openDetailModal(user)"
                            >
                              <i class="fas fa-eye me-2 text-info"></i> 查看詳情
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item text-warning"
                              href="javascript:;"
                              @click="openActionModal(user, 'warning')"
                              >發送警告</a
                            >
                          </li>
                          <li v-if="user.status === 'active'">
                            <a
                              class="dropdown-item text-danger"
                              href="javascript:;"
                              @click="openActionModal(user, 'suspend')"
                              >停權用戶</a
                            >
                          </li>
                          <li v-else>
                            <a
                              class="dropdown-item text-success"
                              href="javascript:;"
                              @click="restoreUser(user)"
                              >恢復用戶</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item text-danger"
                              href="javascript:;"
                              @click="deleteUser(user)"
                              >刪除用戶</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div v-else class="text-xs text-secondary text-center">
                        Read Only
                      </div>
                    </td>
                  </tr>
                  <tr v-if="users.length === 0">
                    <td colspan="7" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Pagination -->
            <div
              class="d-flex justify-content-center mt-3"
              v-if="pagination.total > 0"
            >
              <soft-pagination color="success">
                <soft-pagination-item
                  prev
                  @click="changePage(pagination.current_page - 1)"
                  :disabled="pagination.current_page === 1"
                />
                <soft-pagination-item
                  label
                  v-for="page in pagination.last_page"
                  :key="page"
                  :active="page === pagination.current_page"
                  @click="changePage(page)"
                  >{{ page }}</soft-pagination-item
                >
                <soft-pagination-item
                  next
                  @click="changePage(pagination.current_page + 1)"
                  :disabled="pagination.current_page === pagination.last_page"
                />
              </soft-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Modal -->
    <div
      v-if="showActionModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="btn-close" @click="closeActionModal">
              X
            </button>
          </div>
          <div class="modal-body">
            <p>
              用戶: <strong>{{ selectedUser?.name }}</strong>
            </p>
            <div class="form-group">
              <label>原因 (必填)</label>
              <textarea
                class="form-control"
                v-model="actionReason"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeActionModal"
            >
              關閉
            </button>
            <button type="button" class="btn btn-primary" @click="submitAction">
              確認
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Detail Modal -->
    <user-detail-modal
      :show="showDetailModal"
      :user="selectedUser"
      @close="closeDetailModal"
    />
  </div>
</template>

<script>
import UserDetailModal from "./components/UserDetailModal.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftInput from "@/components/SoftInput.vue";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import request from "@/utils/request"; // Removed unused Swal import
import { hasPermission } from "@/utils/permissions";

export default {
  name: "Users",
  components: {
    UserDetailModal,
    SoftBadge,
    SoftButton,
    SoftInput,
    SoftPagination,
    SoftPaginationItem,
  },
  data() {
    return {
      users: [],
      filters: {
        email: "",
        phone: "",
        status: "",
        is_seller: "",
      },
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 10,
      },
      showActionModal: false,
      showDetailModal: false,
      modalType: "", // 'warning' or 'suspend'
      selectedUser: null,
      actionReason: "",
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchUsers(page = 1) {
      try {
        const params = {
          page,
          ...this.filters,
        };
        Object.keys(params).forEach(
          (key) =>
            (params[key] === "" || params[key] === null) && delete params[key]
        );

        const response = await request.get("/api/admin/users", { params });
        this.users = response.data.data;
        this.pagination = response.data.meta;
      } catch (error) {
        console.error("Failed to fetch users", error);
      }
    },
    resetFilters() {
      this.filters = {
        email: "",
        phone: "",
        status: "",
        is_seller: "",
      };
      this.fetchUsers(1);
    },
    changePage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.fetchUsers(page);
      }
    },
    openActionModal(user, type) {
      this.selectedUser = user;
      this.modalType = type;
      this.actionReason = "";
      this.showActionModal = true;
    },
    closeActionModal() {
      this.showActionModal = false;
      this.selectedUser = null;
    },
    async submitAction() {
      if (!this.actionReason) {
        this.$swal.fire("提示", "原因為必填", "warning");
        return;
      }

      try {
        if (this.modalType === "warning") {
          await request.post(
            `/api/admin/users/${this.selectedUser.id}/warning`,
            { reason: this.actionReason }
          );
        } else {
          await request.post(
            `/api/admin/users/${this.selectedUser.id}/suspend`,
            { reason: this.actionReason }
          );
        }
        this.closeActionModal();
        this.fetchUsers(this.pagination.current_page);
      } catch (error) {
        this.$swal.fire("錯誤", "操作失敗", "error");
      }
    },
    async restoreUser(user) {
      this.$swal({
        title: `恢復用戶 "${user.name}"?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.post(`/api/admin/users/${user.id}/restore`);
            this.fetchUsers(this.pagination.current_page);
            this.$swal.fire("成功", "用戶已恢復", "success");
          } catch (error) {
            this.$swal.fire("錯誤", "恢復用戶失敗", "error");
          }
        }
      });
    },
    async deleteUser(user) {
      this.$swal({
        title: `您確定要刪除用戶 "${user.name}" 嗎？`,
        text: "此操作無法復原。",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea0606",
        confirmButtonText: "確定刪除",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.delete(`/api/admin/users/${user.id}`);
            this.fetchUsers(this.pagination.current_page);
            this.$swal.fire("已刪除", "用戶已成功刪除。", "success");
          } catch (error) {
            this.$swal.fire("錯誤", "刪除用戶失敗", "error");
          }
        }
      });
    },
    openDetailModal(user) {
      this.selectedUser = user;
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.selectedUser = null;
    },
  },
  created() {
    this.fetchUsers();
  },
};
</script>
